// import React, { useState, useEffect } from 'react'
// import { X, Upload, Plus, Trash } from 'lucide-react'
// import axios from 'axios'
// import { BASE_URL } from '../apiConfig'
// import Cookies from 'js-cookie'
// import { toast } from 'sonner'
// import Loading from '../element/Loading'

// export default function EditProduct({ onClose, onSuccess, productToEdit }) {
//   const [loading, setLoading] = useState(false)
//   const [hasVariants, setHasVariants] = useState(false)
//   const [variants, setVariants] = useState([])
//   const [variantCombinations, setVariantCombinations] = useState([])
//   const [availableColors, setAvailableColors] = useState([])
//   const [availableSizes, setAvailableSizes] = useState([])
//   const [selectedColor, setSelectedColor] = useState('')
//   const [selectedSize, setSelectedSize] = useState('')
//   const token = Cookies.get('WEB_SSR')

//   const [formData, setFormData] = useState({
//     name: '',
//     price: '',
//     price_achat: '',
//     qty: '',
//     image: null,
//     imagePreview: null
//   })

//   useEffect(() => {
//     if (productToEdit) {
//       const hasVars = productToEdit.has_variants || false
      
//       setFormData({
//         name: productToEdit.name || '',
//         price: productToEdit.price || '',
//         price_achat: productToEdit.price_achat || '',
//         qty: !hasVars ? (productToEdit.qty || '') : '',
//         image: null,
//         imagePreview: productToEdit.image ? `${BASE_URL}/storage/${productToEdit.image}` : null
//       })
      
//       setHasVariants(hasVars)
      
//       // Load existing variant combinations
//       if (hasVars && productToEdit.variants && productToEdit.variants.length > 0) {
//         const combinations = productToEdit.variants.map(variant => ({
//           variant_ids: [
//             variants.find(v => v.name === variant.color && v.type === 'color')?.id,
//             variants.find(v => v.name === variant.size && v.type === 'size')?.id
//           ].filter(id => id),
//           variant_names: [variant.color, variant.size],
//           variant_types: ['color', 'size'],
//           stock: variant.stock || 0
//         }))
//         setVariantCombinations(combinations)
//       }
//     }
//   }, [productToEdit, variants])

//   useEffect(() => {
//     const fetchVariants = async () => {
//       try {
//         const response = await axios.get(`${BASE_URL}/api/variants`, {
//           headers: { 
//             Authorization: `Bearer ${token}`,
//             Accept: 'application/json'
//           }
//         })
//         if (response.data.success) {
//           const allVariants = response.data.data
//           setVariants(allVariants)
          
//           // Separate colors and sizes
//           const colors = allVariants.filter(v => v.type === 'color')
//           const sizes = allVariants.filter(v => v.type === 'size')
//           setAvailableColors(colors)
//           setAvailableSizes(sizes)
//         }
//       } catch (error) {
//         console.error('Error fetching variants:', error)
//         toast.error('Failed to load variants')
//       }
//     }
    
//     if (token) {
//       fetchVariants()
//     }
//   }, [token])

//   const handleInputChange = (e) => {
//     const { name, value } = e.target
//     setFormData(prev => ({ ...prev, [name]: value }))
//   }

//   const handleImageChange = (e) => {
//     const file = e.target.files[0]
//     if (file) {
//       setFormData(prev => ({
//         ...prev,
//         image: file,
//         imagePreview: URL.createObjectURL(file)
//       }))
//     }
//   }

//   const handleVariantToggle = (e) => {
//     setHasVariants(e.target.checked)
//     if (e.target.checked) {
//       setFormData(prev => ({ ...prev, qty: '' }))
//     } else {
//       setVariantCombinations([])
//     }
//   }

//   const addVariantCombination = () => {
//     if (!selectedColor && !selectedSize) {
//       toast.error('Please select both color and size')
//       return
//     }

//     // Check if combination already exists
//     const exists = variantCombinations.some(combo => 
//       combo.variant_ids.includes(parseInt(selectedColor)) && 
//       combo.variant_ids.includes(parseInt(selectedSize))
//     )

//     if (exists) {
//       toast.error('This combination already exists')
//       return
//     }

//     const colorVariant = availableColors.find(c => c.id == selectedColor)
//     const sizeVariant = availableSizes.find(s => s.id == selectedSize)

//     const newCombination = {
//       variant_ids: [parseInt(selectedColor), parseInt(selectedSize)],
//       variant_names: [colorVariant.name, sizeVariant.name],
//       variant_types: ['color', 'size'],
//       stock: 0
//     }

//     setVariantCombinations(prev => [...prev, newCombination])
    
//     // Reset selections
//     setSelectedColor('')
//     setSelectedSize('')
//   }

//   const removeVariantCombination = (index) => {
//     setVariantCombinations(prev => prev.filter((_, i) => i !== index))
//   }

//   const updateCombinationStock = (index, stock) => {
//     setVariantCombinations(prev => {
//       const updated = [...prev]
//       updated[index] = { ...updated[index], stock: parseInt(stock) || 0 }
//       return updated
//     })
//   }

//   const getCombinationName = (combination) => {
//     const color = combination.variant_names[0]
//     const size = combination.variant_names[1]
//     return `${color} / ${size}`
//   }

//   const handleSubmit = async (e) => {
//     e.preventDefault()
    
//     if (!formData.name || !formData.price || !formData.price_achat) {
//       toast.error('Please fill in required fields')
//       return
//     }

//     if (hasVariants && variantCombinations.length === 0) {
//       toast.error('Please add at least one variant combination')
//       return
//     }

//     if (!hasVariants && !formData.qty) {
//       toast.error('Please enter quantity')
//       return
//     }

//     try {
//       const data = new FormData()
//       data.append('name', formData.name)
//       data.append('price', formData.price)
//       data.append('price_achat', formData.price_achat)
//       data.append('has_variants', hasVariants ? 1 : 0)
      
//       if (!hasVariants) {
//         data.append('qty', formData.qty)
//       }
      
//       if (formData.image) {
//         data.append('image', formData.image)
//       }

//       // Add variant combinations data only if product has variants
//       if (hasVariants) {
//         variantCombinations.forEach((combination, index) => {
//           combination.variant_ids.forEach((variantId, idx) => {
//             data.append(`variant_combinations[${index}][variant_ids][${idx}]`, variantId)
//           })
//           data.append(`variant_combinations[${index}][stock]`, combination.stock)
//         })
//       }

//       const response = await axios.post(
//         `${BASE_URL}/api/products-update/${productToEdit.id}`,
//         data,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             Accept: 'application/json'
//           }
//         }
//       )

//       if (response.data.success) {
//         toast.success('Product updated successfully')
//         if (onSuccess) onSuccess()
//       } else {
//         toast.error(response.data.message || 'Operation failed')
//       }
//     } catch (error) {
//       console.error('Error submitting form:', error)
//       if (error.response?.data?.errors) {
//         const errors = Object.values(error.response.data.errors).flat()
//         toast.error(errors.join('\n'))
//       } else {
//         toast.error(error.response?.data?.message || 'Operation failed')
//       }
//     } finally {
//       setLoading(false)
//     }
//   }

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
//       <div className="bg-white dark:bg-gray-900 rounded-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto border border-gray-200 dark:border-gray-800 shadow-xl">
//         {/* Modal Header */}
//         <div className="sticky top-0 z-10 flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900">
//           <div>
//             <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-50">
//               Edit Product
//             </h3>
//             <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
//               Update product details
//             </p>
//           </div>
//           <button
//             onClick={onClose}
//             disabled={loading}
//             className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors disabled:opacity-50"
//           >
//             <X className="w-5 h-5 text-gray-500 dark:text-gray-400" />
//           </button>
//         </div>

//         {/* Modal Body */}
//         <form onSubmit={handleSubmit} className="p-6 max-lg:p-3 space-y-6">

//           {/* Variant Combinations Section */}
//           {hasVariants && (
//             <div className="space-y-4">
//               <div className="flex items-center justify-between">
//                 <label className="text-xs font-medium text-gray-700 dark:text-gray-300">
//                   Variant Combinations
//                 </label>
//               </div>

//               {/* Combinations List */}
//               {variantCombinations.length > 0 ? (
//                 <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 space-y-2">
//                   <h4 className="text-xs font-medium text-gray-700 dark:text-gray-300">
//                     Added Combinations ({variantCombinations.length})
//                   </h4>
                  
//                   {variantCombinations.map((combination, index) => (
//                     <div key={index} className="bg-white dark:bg-gray-900 rounded-lg px-4 max-lg:px-2 py-2 border border-gray-200 dark:border-gray-800">
//                       <div className="flex justify-between items-center">
//                         <div className="flex items-center gap-3">
//                           {/* Color Preview */}
//                           {combination.variant_types[0] === 'color' && (
//                             <div 
//                               className="w-5 h-5 rounded border border-gray-300"
//                               style={{ 
//                                 backgroundColor: variants.find(v => v.id === combination.variant_ids[0])?.value || '#ccc' 
//                               }}
//                             />
//                           )}
//                           <div>
//                             <h4 className="text-xs font-medium text-gray-900 dark:text-gray-100">
//                               {getCombinationName(combination)}
//                             </h4>
//                             <p className="text-[11px] text-gray-500">
//                               Combination #{index + 1}
//                             </p>
//                           </div>
//                         </div>
//                         {/* Stock Input */}
//                         <div className="w-[50%]">
//                           <div className="space-y-1">
//                             <input
//                               type="number"
//                               value={combination.stock}
//                               onChange={(e) => updateCombinationStock(index, e.target.value)}
//                               required
//                               min="0"
//                               disabled={loading}
//                               className="w-32 px-2 py-1.5 text-xs border border-gray-300 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-900 dark:focus:ring-gray-600 focus:border-transparent disabled:opacity-50"
//                               placeholder="Enter stock"
//                             />
//                             <label className="text-[11px] ml-3 font-medium text-gray-700 dark:text-gray-300">
//                               Stock Quantity *
//                             </label>
//                             <div className="">
//                               <div className=" bg-gray-200 dark:bg-gray-700 rounded-full h-2">
//                                 <div 
//                                   className={`h-2 rounded-full ${
//                                     combination.stock > 50 ? 'bg-green-500' :
//                                     combination.stock > 10 ? 'bg-yellow-500' : 'bg-red-500'
//                                   }`}
//                                   style={{ width: `${Math.min(combination.stock, 100)}%` }}
//                                 />
//                               </div>
//                             </div>
//                           </div>
//                         </div>
                        
//                         <button
//                           type="button"
//                           onClick={() => removeVariantCombination(index)}
//                           disabled={loading}
//                           className="p-1 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg text-red-600 dark:text-red-400 transition-colors disabled:opacity-50"
//                         >
//                           <Trash className="w-3 h-3" />
//                         </button>
//                       </div>
//                     </div>
//                   ))}

//                   {/* Total Stock Summary */}
//                   <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4">
//                     <div className="flex items-center justify-between">
//                       <div>
//                         <p className="text-sm font-medium text-gray-900 dark:text-gray-100">
//                           Total Stock Summary
//                         </p>
//                         <p className="text-xs text-gray-500 dark:text-gray-400">
//                           Across all combinations
//                         </p>
//                       </div>
//                       <div className="text-right">
//                         <p className="text-lg font-bold text-gray-900 dark:text-gray-100">
//                           {variantCombinations.reduce((sum, combo) => sum + combo.stock, 0)}
//                         </p>
//                         <p className="text-xs text-gray-500 dark:text-gray-400">
//                           Total units
//                         </p>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ) : (
//                 <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-8 text-center">
//                   <div className="w-16 h-16 mx-auto mb-4 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center">
//                     <Plus className="w-8 h-8 text-gray-400" />
//                   </div>
//                   <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
//                     No Variant Combinations Added
//                   </h4>
//                   <p className="text-xs text-gray-500 dark:text-gray-400 max-w-sm mx-auto">
//                     Add color and size combinations to create different product variants. Each combination will have its own stock.
//                   </p>
//                 </div>
//               )}

//               {/* Add Combination Form */}
//               <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
//                 <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                   {/* Color Selection */}
//                   <div className="space-y-2">
//                     <label className="text-xs font-medium text-gray-700 dark:text-gray-300">
//                       Select Color
//                     </label>
//                     <select
//                       value={selectedColor}
//                       onChange={(e) => setSelectedColor(e.target.value)}
//                       disabled={loading}
//                       className="w-full px-3 py-2 text-xs border border-gray-300 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-900 dark:focus:ring-gray-600 focus:border-transparent disabled:opacity-50"
//                     >
//                       <option value="">Select Color</option>
//                       {availableColors.map(color => (
//                         <option key={color.id} value={color.id}>
//                           {color.name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>

//                   {/* Size Selection */}
//                   <div className="space-y-2">
//                     <label className="text-xs font-medium text-gray-700 dark:text-gray-300">
//                       Select Size
//                     </label>
//                     <select
//                       value={selectedSize}
//                       onChange={(e) => setSelectedSize(e.target.value)}
//                       disabled={loading}
//                       className="w-full px-3 py-2 text-xs border border-gray-300 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-900 dark:focus:ring-gray-600 focus:border-transparent disabled:opacity-50"
//                     >
//                       <option value="">Select Size</option>
//                       {availableSizes.map(size => (
//                         <option key={size.id} value={size.id}>
//                           {size.name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>

//                   {/* Add Button */}
//                   <div className="flex items-end">
//                     <button
//                       type="button"
//                       onClick={addVariantCombination}
//                       disabled={loading || !selectedColor && !selectedSize}
//                       className="w-full px-4 py-2 text-xs font-medium text-white bg-[#171717] rounded-lg hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//                     >
//                       Add Combination
//                     </button>
//                   </div>
//                 </div>
//               </div>
              
//             </div>
//           )}

//           <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4">
//             <div className="flex items-center gap-3">
//               <input
//                 type="checkbox"
//                 id="hasVariants"
//                 checked={hasVariants}
//                 onChange={handleVariantToggle}
//                 disabled={loading}
//                 className="w-4 h-4 rounded border-gray-300 cursor-pointer"
//               />
//               <label htmlFor="hasVariants" className="flex-1 cursor-pointer">
//                 <p className="text-sm font-medium text-gray-900 dark:text-gray-100">
//                   This product has variants (color, size, etc.)
//                 </p>
//                 <p className="text-xs text-gray-600 dark:text-gray-400">
//                   {hasVariants 
//                     ? 'Each variant combination will have its own stock' 
//                     : 'Product will have a single total quantity'}
//                 </p>
//               </label>
//             </div>
//           </div>

//           {/* Basic Information */}
//           <div className='grid grid-cols-2 max-md:grid-cols-1 gap-16'>
//             <div className="w-50 grid grid-cols-1 h-[70%]">
//               {/* Product Name */}
//               <div className="space-y-1" >
//                 <label className="text-xs font-medium text-gray-700 dark:text-gray-300">
//                   Product Name *
//                 </label>
//                 <input
//                   type="text"
//                   name="name"
//                   value={formData.name}
//                   onChange={handleInputChange}
//                   required
//                   disabled={loading}
//                   className="w-full px-3 py-2 text-xs border border-gray-300 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-900 dark:focus:ring-gray-600 focus:border-transparent disabled:opacity-50"
//                   placeholder="Enter product name"
//                 />
//               </div>

//               {/* Price */}
//               <div className="space-y-1">
//                 <label className="text-xs font-medium text-gray-700 dark:text-gray-300">
//                   Price *
//                 </label>
//                 <div className="relative">
//                   <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-xs">MAD</span>
//                   <input
//                     type="number"
//                     name="price"
//                     value={formData.price}
//                     onChange={handleInputChange}
//                     required
//                     min="0"
//                     step="0.01"
//                     disabled={loading}
//                     className="w-full pl-12 pr-3 py-2 text-xs border border-gray-300 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-900 dark:focus:ring-gray-600 focus:border-transparent disabled:opacity-50"
//                     placeholder="0.00"
//                   />
//                 </div>
//               </div>

//               {/* Price d'achat */}
//               <div className="space-y-1">
//                 <label className="text-xs font-medium text-gray-700 dark:text-gray-300">
//                   Price d'achat *
//                 </label>
//                 <div className="relative">
//                   <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-xs">MAD</span>
//                   <input
//                     type="number"
//                     name="price_achat"
//                     value={formData.price_achat}
//                     onChange={handleInputChange}
//                     required
//                     min="0"
//                     step="0.01"
//                     disabled={loading}
//                     className="w-full pl-12 pr-3 py-2 text-xs border border-gray-300 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-900 dark:focus:ring-gray-600 focus:border-transparent disabled:opacity-50"
//                     placeholder="0.00"
//                   />
//                 </div>
//               </div>

//               {/* Quantity (for products without variants) */}
//               {!hasVariants && (
//                 <div className="space-y-1">
//                   <label className="text-xs font-medium text-gray-700 dark:text-gray-300">
//                     Total Quantity *
//                   </label>
//                   <input
//                     type="number"
//                     name="qty"
//                     value={formData.qty}
//                     onChange={handleInputChange}
//                     required={!hasVariants}
//                     min="0"
//                     step="1"
//                     disabled={loading}
//                     className="w-full px-3 py-2 text-xs border border-gray-300 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-900 dark:focus:ring-gray-600 focus:border-transparent disabled:opacity-50"
//                     placeholder="Enter quantity"
//                   />
//                 </div>
//               )}
//             </div>

//             {/* Image Upload */}
//             <div className="w-50">
//               <label className="text-xs font-medium text-gray-700 dark:text-gray-300">
//                 Product Image
//               </label>
//               <div className="mb-4 gap-4">
//                 <label className={`flex flex-col items-center justify-center w-56 h-56 border-2 ${formData.imagePreview ? 'border-solid' : 'border-dashed'} border-gray-300 dark:border-gray-700 rounded-lg cursor-pointer hover:border-gray-400 dark:hover:border-gray-600 transition-colors ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}>
//                   {formData.imagePreview ? (
//                     <img 
//                       src={formData.imagePreview} 
//                       alt="Preview" 
//                       className="w-full h-full object-cover rounded-lg"
//                     />
//                   ) : (
//                     <div className="flex flex-col items-center">
//                       <Upload className="w-8 h-8 text-gray-400 mb-2" />
//                       <span className="text-xs text-gray-500">Upload Image</span>
//                     </div>
//                   )}
//                   <input
//                     type="file"
//                     accept="image/*"
//                     onChange={handleImageChange}
//                     disabled={loading}
//                     className="hidden"
//                   />
//                 </label>
//                 <div className="flex-1 mt-3">
//                   <p className="text-[11px] text-gray-500 dark:text-gray-400">
//                     Recommended: 500x500px, JPG, PNG, GIF
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>          

//           {/* Modal Footer */}
//           <div className="sticky bottom-0 pt-6 border-t border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 flex justify-end gap-3">
//             <button
//               type="button"
//               onClick={onClose}
//               disabled={loading}
//               className="px-3 py-2 text-xs font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-800 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors border border-gray-300 dark:border-gray-700 disabled:opacity-50"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               disabled={loading}
//               className={`px-3 py-2 text-xs font-medium text-white rounded-lg transition-colors shadow-sm flex items-center gap-2 ${
//                 !loading
//                   ? "bg-[#171717] hover:bg-gray-800"
//                   : "bg-gray-400 cursor-not-allowed"
//               }`}
//             >
//               {loading ? (
//                 <>
//                   <Loading size={5} />
//                   Updating...
//                 </>
//               ) : (
//                 <>
//                   Update Product
//                 </>
//               )}
//             </button>
//           </div>

//         </form>
//       </div>
//     </div>
//   )
// }


import React, { useState, useEffect } from 'react'
import { X, Upload, Plus, Trash } from 'lucide-react'
import axios from 'axios'
import { BASE_URL, EXTERNAL_BASE_URL } from '../apiConfig'
import Cookies from 'js-cookie'
import { toast } from 'sonner'
import Loading from '../element/Loading'
import { useTranslation } from '../LanguageContext'

export default function EditProduct({ onClose, onSuccess, productToEdit }) {
  const [loading, setLoading] = useState(false)
  const [hasVariants, setHasVariants] = useState(false)
  const [variantType, setVariantType] = useState('both') // 'colors', 'sizes', 'both'
  const [variants, setVariants] = useState([])
  const [variantCombinations, setVariantCombinations] = useState([])
  const [availableColors, setAvailableColors] = useState([])
  const [availableSizes, setAvailableSizes] = useState([])
  const [selectedColor, setSelectedColor] = useState('')
  const [selectedSize, setSelectedSize] = useState('')
  const token = Cookies.get('WEB_SSR')
  const { t } = useTranslation()

  const [formData, setFormData] = useState({
    name: '',
    price: '',
    price_achat: '',
    qty: '',
    image: null,
    imagePreview: null
  })

  // Load product data when productToEdit changes
  useEffect(() => {
    if (productToEdit) {
      const hasVars = productToEdit.has_variants || false
      
      setFormData({
        name: productToEdit.name || '',
        price: productToEdit.price || '',
        price_achat: productToEdit.price_achat || '',
        qty: !hasVars ? (productToEdit.qty || '') : '',
        image: null,
        imagePreview: productToEdit.image ? 
        //  `${BASE_URL}/storage/${productToEdit.image}` 
           productToEdit.source_id ? `${EXTERNAL_BASE_URL}/storage/${productToEdit.image}` : `${BASE_URL}/storage/${productToEdit.image}`
         : null
      })
      
      setHasVariants(hasVars)
      
      // Load existing variant combinations
      if (hasVars && productToEdit.variants && productToEdit.variants.length > 0) {
        // Determine variant type from existing variants
        const hasColor = productToEdit.variants.some(v => v.color)
        const hasSize = productToEdit.variants.some(v => v.size)
        
        let detectedType = 'both'
        if (hasColor && !hasSize) detectedType = 'colors'
        else if (!hasColor && hasSize) detectedType = 'sizes'
        else detectedType = 'both'
        
        setVariantType(detectedType)
        
        const combinations = productToEdit.variants.map(variant => {
          if (detectedType === 'colors') {
            return {
              variant_ids: [variants.find(v => v.name === variant.color && v.type === 'color')?.id].filter(id => id),
              variant_names: [variant.color],
              variant_types: ['color'],
              variant_values: [variants.find(v => v.name === variant.color && v.type === 'color')?.value],
              stock: variant.stock || 0
            }
          } else if (detectedType === 'sizes') {
            return {
              variant_ids: [variants.find(v => v.name === variant.size && v.type === 'size')?.id].filter(id => id),
              variant_names: [variant.size],
              variant_types: ['size'],
              variant_values: [],
              stock: variant.stock || 0
            }
          } else {
            return {
              variant_ids: [
                variants.find(v => v.name === variant.color && v.type === 'color')?.id,
                variants.find(v => v.name === variant.size && v.type === 'size')?.id
              ].filter(id => id),
              variant_names: [variant.color, variant.size],
              variant_types: ['color', 'size'],
              variant_values: [variants.find(v => v.name === variant.color && v.type === 'color')?.value, null],
              stock: variant.stock || 0
            }
          }
        })
        setVariantCombinations(combinations)
      }
    }
  }, [productToEdit, variants])

  // Fetch variants
  useEffect(() => {
    const fetchVariants = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/variants`, {
          headers: { 
            Authorization: `Bearer ${token}`,
            Accept: 'application/json'
          }
        })
        if (response.data.success) {
          const allVariants = response.data.data
          setVariants(allVariants)
          
          const colors = allVariants.filter(v => v.type === 'color')
          const sizes = allVariants.filter(v => v.type === 'size')
          setAvailableColors(colors)
          setAvailableSizes(sizes)
        }
      } catch (error) {
        console.error('Error fetching variants:', error)
        toast.error(t('product.add.load_variants_error'))
      }
    }
    
    if (token) {
      fetchVariants()
    }
  }, [token])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleImageChange = (e) => {
    const file = e.target.files[0]
    if (file) {
      setFormData(prev => ({
        ...prev,
        image: file,
        imagePreview: URL.createObjectURL(file)
      }))
    }
  }

  const handleVariantToggle = (e) => {
    setHasVariants(e.target.checked)
    if (e.target.checked) {
      setFormData(prev => ({ ...prev, qty: '' }))
    } else {
      setVariantCombinations([])
    }
  }

  const handleVariantTypeChange = (type) => {
    setVariantType(type)
    setVariantCombinations([]) // Reset combinations when type changes
    setSelectedColor('')
    setSelectedSize('')
  }

  const addVariantCombination = () => {
    // Validate based on variant type
    if (variantType === 'colors' && !selectedColor) {
      toast.error(t('product.add.select_color_error'))
      return
    }
    if (variantType === 'sizes' && !selectedSize) {
      toast.error(t('product.add.select_size_error'))
      return
    }
    if (variantType === 'both' && (!selectedColor || !selectedSize)) {
      toast.error(t('product.add.select_both_error'))
      return
    }

    let newCombination = {}
    
    if (variantType === 'colors') {
      const colorVariant = availableColors.find(c => c.id == selectedColor)
      
      const exists = variantCombinations.some(combo => 
        combo.variant_ids.length === 1 && combo.variant_ids[0] === parseInt(selectedColor)
      )
      
      if (exists) {
        toast.error(t('product.add.color_exists'))
        return
      }
      
      newCombination = {
        variant_ids: [parseInt(selectedColor)],
        variant_names: [colorVariant.name],
        variant_types: ['color'],
        variant_values: [colorVariant.value],
        stock: 0
      }
      
      setSelectedColor('')
      
    } else if (variantType === 'sizes') {
      const sizeVariant = availableSizes.find(s => s.id == selectedSize)
      
      const exists = variantCombinations.some(combo => 
        combo.variant_ids.length === 1 && combo.variant_ids[0] === parseInt(selectedSize)
      )
      
      if (exists) {
        toast.error(t('product.add.size_exists'))
        return
      }
      
      newCombination = {
        variant_ids: [parseInt(selectedSize)],
        variant_names: [sizeVariant.name],
        variant_types: ['size'],
        variant_values: [],
        stock: 0
      }
      
      setSelectedSize('')
      
    } else {
      const colorVariant = availableColors.find(c => c.id == selectedColor)
      const sizeVariant = availableSizes.find(s => s.id == selectedSize)
      
      const exists = variantCombinations.some(combo => 
        combo.variant_ids.includes(parseInt(selectedColor)) && 
        combo.variant_ids.includes(parseInt(selectedSize))
      )
      
      if (exists) {
        toast.error(t('product.add.combination_exists'))
        return
      }
      
      newCombination = {
        variant_ids: [parseInt(selectedColor), parseInt(selectedSize)],
        variant_names: [colorVariant.name, sizeVariant.name],
        variant_types: ['color', 'size'],
        variant_values: [colorVariant.value, null],
        stock: 0
      }
      
      setSelectedColor('')
      setSelectedSize('')
    }

    setVariantCombinations(prev => [...prev, newCombination])
  }

  const removeVariantCombination = (index) => {
    setVariantCombinations(prev => prev.filter((_, i) => i !== index))
  }

  const updateCombinationStock = (index, stock) => {
    setVariantCombinations(prev => {
      const updated = [...prev]
      updated[index] = { ...updated[index], stock: parseInt(stock) || 0 }
      return updated
    })
  }

  const getCombinationName = (combination) => {
    if (combination.variant_types.length === 1) {
      return combination.variant_names[0]
    }
    return `${combination.variant_names[0]} / ${combination.variant_names[1]}`
  }

  const getCombinationPreview = (combination) => {
    if (combination.variant_types[0] === 'color' && combination.variant_values[0]) {
      return (
        <div 
          className="w-5 h-5 rounded border border-gray-300"
          style={{ backgroundColor: combination.variant_values[0] }}
        />
      )
    }
    return null
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    
    if (!formData.name || !formData.price || !formData.price_achat) {
      toast.error(t('product.add.fill_fields'))
      setLoading(false)
      return
    }

    if (hasVariants && variantCombinations.length === 0) {
      toast.error(t('product.add.add_variant'))
      setLoading(false)
      return
    }

    if (!hasVariants && !formData.qty) {
      toast.error(t('product.add.enter_qty'))
      setLoading(false)
      return
    }

    try {
      const data = new FormData()
      data.append('name', formData.name)
      data.append('price', formData.price)
      data.append('price_achat', formData.price_achat)
      data.append('has_variants', hasVariants ? 1 : 0)
      data.append('_method', 'PUT')
      
      if (!hasVariants) {
        data.append('qty', formData.qty)
      }
      
      if (formData.image) {
        data.append('image', formData.image)
      }

      // Add variant type info for products with variants
      if (hasVariants) {
        data.append('variant_type', variantType)
        
        variantCombinations.forEach((combination, index) => {
          combination.variant_ids.forEach((variantId, idx) => {
            data.append(`variant_combinations[${index}][variant_ids][${idx}]`, variantId)
          })
          data.append(`variant_combinations[${index}][stock]`, combination.stock)
        })
      }

      const response = await axios.post(
        `${BASE_URL}/api/products-update/${productToEdit.id}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
           'Content-Type': 'multipart/form-data'
          }
        }
      )

      if (response.data.success) {
        toast.success(t('product.edit.success'))
        if (onSuccess) onSuccess()
      } else {
        toast.error(response.data.message || t('product.add.operation_failed'))
      }
    } catch (error) {
      console.error('Error submitting form:', error)
      if (error.response?.data?.errors) {
        const errors = Object.values(error.response.data.errors).flat()
        toast.error(errors.join('\n'))
      } else {
        toast.error(error.response?.data?.message || t('product.add.operation_failed'))
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="bg-white dark:bg-gray-900 rounded-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto border border-gray-200 dark:border-gray-800 shadow-xl">
        {/* Modal Header */}
        <div className="sticky top-0 z-10 flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900">
          <div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-50">
              {t('product.edit.title')}
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
              {t('product.edit.desc')}
            </p>
          </div>
          <button
            onClick={onClose}
            disabled={loading}
            className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors disabled:opacity-50"
          >
            <X className="w-5 h-5 text-gray-500 dark:text-gray-400" />
          </button>
        </div>

        {/* Modal Body */}
        <form onSubmit={handleSubmit} className="p-6 max-lg:p-3 space-y-6">

          {/* Basic Information */}
          <div className='grid grid-cols-2 max-md:grid-cols-1 gap-16'>
            <div className="w-50 grid grid-cols-1 h-[70%]">
              <div className="space-y-1">
                <label className="text-xs font-medium text-gray-700 dark:text-gray-300">
                  {t('product.edit.name')}
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  disabled={loading}
                  className="w-full px-3 py-2 text-xs border border-gray-300 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-900 dark:focus:ring-gray-600 focus:border-transparent disabled:opacity-50"
                  placeholder={t('product.edit.name.placeholder')}
                />
              </div>

              <div className="space-y-1">
                <label className="text-xs font-medium text-gray-700 dark:text-gray-300">
                  {t('product.edit.price')}
                </label>
                <div className="relative">
                  <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-xs">MAD</span>
                  <input
                    type="number"
                    name="price"
                    value={formData.price}
                    onChange={handleInputChange}
                    required
                    min="0"
                    step="0.01"
                    disabled={loading}
                    className="w-full pl-12 pr-3 py-2 text-xs border border-gray-300 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-900 dark:focus:ring-gray-600 focus:border-transparent disabled:opacity-50"
                    placeholder="0.00"
                  />
                </div>
              </div>

              <div className="space-y-1">
                <label className="text-xs font-medium text-gray-700 dark:text-gray-300">
                  {t('product.edit.purchase_price')}
                </label>
                <div className="relative">
                  <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-xs">MAD</span>
                  <input
                    type="number"
                    name="price_achat"
                    value={formData.price_achat}
                    onChange={handleInputChange}
                    required
                    min="0"
                    step="0.01"
                    disabled={loading}
                    className="w-full pl-12 pr-3 py-2 text-xs border border-gray-300 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-900 dark:focus:ring-gray-600 focus:border-transparent disabled:opacity-50"
                    placeholder="0.00"
                  />
                </div>
              </div>

              {!hasVariants && (
                <div className="space-y-1">
                  <label className="text-xs font-medium text-gray-700 dark:text-gray-300">
                    {t('product.edit.quantity')}
                  </label>
                  <input
                    type="number"
                    name="qty"
                    value={formData.qty}
                    onChange={handleInputChange}
                    required={!hasVariants}
                    min="0"
                    step="1"
                    disabled={loading}
                    className="w-full px-3 py-2 text-xs border border-gray-300 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-900 dark:focus:ring-gray-600 focus:border-transparent disabled:opacity-50"
                    placeholder={t('product.edit.quantity.placeholder')}
                  />
                </div>
              )}
            </div>

            {/* Image Upload */}
            <div className="w-50">
              <label className="text-xs font-medium text-gray-700 dark:text-gray-300">
                {t('product.edit.image')}
              </label>
              <div className="mb-4 gap-4">
                <label className={`flex flex-col items-center justify-center w-56 h-56 border-2 ${formData.imagePreview ? 'border-solid' : 'border-dashed'} border-gray-300 dark:border-gray-700 rounded-lg cursor-pointer hover:border-gray-400 dark:hover:border-gray-600 transition-colors ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}>
                  {formData.imagePreview ? (
                    <img 
                      src={formData.imagePreview} 
                      alt="Preview" 
                      className="w-full h-full object-cover rounded-lg"
                    />
                  ) : (
                    <div className="flex flex-col items-center">
                      <Upload className="w-8 h-8 text-gray-400 mb-2" />
                      <span className="text-xs text-gray-500">{t('product.edit.upload')}</span>
                    </div>
                  )}
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    disabled={loading}
                    className="hidden"
                  />
                </label>
                <div className="flex-1 mt-3">
                  <p className="text-[11px] text-gray-500 dark:text-gray-400">
                    {t('product.edit.recommended')}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Variant Toggle */}
          <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4">
            <div className="flex items-center gap-3">
              <input
                type="checkbox"
                id="hasVariants"
                checked={hasVariants}
                onChange={handleVariantToggle}
                disabled={loading}
                className="w-4 h-4 rounded border-gray-300 cursor-pointer"
              />
              <label htmlFor="hasVariants" className="flex-1 cursor-pointer">
                <p className="text-sm font-medium text-gray-900 dark:text-gray-100">
                  {t('product.edit.has_variants')}
                </p>
                <p className="text-xs text-gray-600 dark:text-gray-400">
                  {hasVariants 
                    ? t('product.edit.variants_stock') 
                    : t('product.edit.no_variants_stock')}
                </p>
              </label>
            </div>
          </div>

          {/* Variant Type Selection (only when variants are enabled) */}
          {hasVariants && (
            <div className="space-y-4">
              <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
                <label className="text-xs font-medium text-gray-700 dark:text-gray-300 mb-3 block">
                  {t('product.edit.variant_type')}
                </label>
                <div className="grid grid-cols-3 gap-3">
                  <button
                    type="button"
                    onClick={() => handleVariantTypeChange('colors')}
                    className={`px-4 py-2 text-xs font-medium rounded-lg transition-colors ${
                      variantType === 'colors'
                        ? 'bg-[#171717] text-white'
                        : 'bg-white dark:bg-gray-900 text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-800'
                    }`}
                  >
                    {t('product.edit.colors_only')}
                  </button>
                  <button
                    type="button"
                    onClick={() => handleVariantTypeChange('sizes')}
                    className={`px-4 py-2 text-xs font-medium rounded-lg transition-colors ${
                      variantType === 'sizes'
                        ? 'bg-[#171717] text-white'
                        : 'bg-white dark:bg-gray-900 text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-800'
                    }`}
                  >
                    {t('product.edit.sizes_only')}
                  </button>
                  <button
                    type="button"
                    onClick={() => handleVariantTypeChange('both')}
                    className={`px-4 py-2 text-xs font-medium rounded-lg transition-colors ${
                      variantType === 'both'
                        ? 'bg-[#171717] text-white'
                        : 'bg-white dark:bg-gray-900 text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-800'
                    }`}
                  >
                    {t('product.edit.colors_sizes')}
                  </button>
                </div>
                <p className="text-[11px] text-gray-500 dark:text-gray-400 mt-3">
                  {variantType === 'colors' && t('common.colors_only_desc')}
                  {variantType === 'sizes' && t('common.sizes_only_desc')}
                  {variantType === 'both' && t('common.both_desc')}
                </p>
              </div>
            </div>
          )}

          {/* Variant Combinations Section */}
          {hasVariants && (
            <div className="space-y-4">
              {/* Add Combination Form */}
              <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  {(variantType === 'colors' || variantType === 'both') && (
                    <div className="space-y-2">
                      <label className="text-xs font-medium text-gray-700 dark:text-gray-300">
                        {t('product.edit.select_color')}
                      </label>
                      <select
                        value={selectedColor}
                        onChange={(e) => setSelectedColor(e.target.value)}
                        disabled={loading}
                        className="w-full px-3 py-2 text-xs border border-gray-300 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-900 dark:focus:ring-gray-600 focus:border-transparent disabled:opacity-50"
                      >
                        <option value="">{t('product.edit.select_color')}</option>
                        {availableColors.map(color => (
                          <option key={color.id} value={color.id}>
                            {color.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {(variantType === 'sizes' || variantType === 'both') && (
                    <div className="space-y-2">
                      <label className="text-xs font-medium text-gray-700 dark:text-gray-300">
                        {t('product.edit.select_size')}
                      </label>
                      <select
                        value={selectedSize}
                        onChange={(e) => setSelectedSize(e.target.value)}
                        disabled={loading}
                        className="w-full px-3 py-2 text-xs border border-gray-300 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-900 dark:focus:ring-gray-600 focus:border-transparent disabled:opacity-50"
                      >
                        <option value="">{t('product.edit.select_size')}</option>
                        {availableSizes.map(size => (
                          <option key={size.id} value={size.id}>
                            {size.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  <div className="flex items-end">
                    <button
                      type="button"
                      onClick={addVariantCombination}
                      disabled={loading || (
                        variantType === 'colors' && !selectedColor ||
                        variantType === 'sizes' && !selectedSize ||
                        variantType === 'both' && (!selectedColor || !selectedSize)
                      )}
                      className="w-full px-4 py-2 text-xs font-medium text-white bg-[#171717] rounded-lg hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {variantType === 'both' ? t('product.edit.add_combination') : variantType === 'colors' ? t('product.edit.add_color') : t('product.edit.add_size')}
                    </button>
                  </div>
                </div>
              </div>

              {/* Combinations List */}
              {variantCombinations.length > 0 ? (
                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 space-y-2">
                  <h4 className="text-xs font-medium text-gray-700 dark:text-gray-300">
                    Added {variantType === 'both' ? 'Combinations' : variantType === 'colors' ? 'Colors' : 'Sizes'} ({variantCombinations.length})
                  </h4>
                  
                  {variantCombinations.map((combination, index) => (
                    <div key={index} className="bg-white dark:bg-gray-900 rounded-lg px-4 max-lg:px-2 py-2 border border-gray-200 dark:border-gray-800">
                      <div className="flex justify-between items-center">
                        <div className="flex items-center gap-3">
                          {combination.variant_types[0] === 'color' && combination.variant_values[0] && (
                            <div 
                              className="w-5 h-5 rounded border border-gray-300"
                              style={{ backgroundColor: combination.variant_values[0] }}
                            />
                          )}
                          <div>
                            <h4 className="text-xs font-medium text-gray-900 dark:text-gray-100">
                              {getCombinationName(combination)}
                            </h4>
                            <p className="text-[11px] text-gray-500">
                              Variant #{index + 1}
                            </p>
                          </div>
                        </div>
                        
                        <div className="w-[50%]">
                          <div className="space-y-1">
                            <input
                              type="number"
                              value={combination.stock}
                              onChange={(e) => updateCombinationStock(index, e.target.value)}
                              required
                              min="0"
                              disabled={loading}
                              className="w-32 px-2 py-1.5 text-xs border border-gray-300 dark:border-gray-700 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-900 dark:focus:ring-gray-600 focus:border-transparent disabled:opacity-50"
                              placeholder={t('common.enter_stock')}
                            />
                            <label className="text-[11px] ml-3 font-medium text-gray-700 dark:text-gray-300">
                              {t('product.add.stock_qty')}
                            </label>
                            <div className="bg-gray-200 dark:bg-gray-700 rounded-full h-2">
                              <div 
                                className={`h-2 rounded-full ${
                                  combination.stock > 50 ? 'bg-green-500' :
                                  combination.stock > 10 ? 'bg-yellow-500' : 'bg-red-500'
                                }`}
                                style={{ width: `${Math.min(combination.stock, 100)}%` }}
                              />
                            </div>
                          </div>
                        </div>
                        
                        <button
                          type="button"
                          onClick={() => removeVariantCombination(index)}
                          disabled={loading}
                          className="p-1 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg text-red-600 dark:text-red-400 transition-colors disabled:opacity-50"
                        >
                          <Trash className="w-3 h-3" />
                        </button>
                      </div>
                    </div>
                  ))}

                  {/* Total Stock Summary */}
                  <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-sm font-medium text-gray-900 dark:text-gray-100">
                          {t('product.add.total_summary')}
                        </p>
                        <p className="text-xs text-gray-500 dark:text-gray-400">
                          {t('product.add.across')}
                        </p>
                      </div>
                      <div className="text-right">
                        <p className="text-lg font-bold text-gray-900 dark:text-gray-100">
                          {variantCombinations.reduce((sum, combo) => sum + combo.stock, 0)}
                        </p>
                        <p className="text-xs text-gray-500 dark:text-gray-400">
                          {t('product.add.total_units')}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-8 text-center">
                  <div className="w-16 h-16 mx-auto mb-4 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center">
                    <Plus className="w-8 h-8 text-gray-400" />
                  </div>
                  <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    {t('product.add.no_combinations')}
                  </h4>
                  <p className="text-xs text-gray-500 dark:text-gray-400 max-w-sm mx-auto">
                    {t('product.add.no_combinations_desc')}
                  </p>
                </div>
              )}
            </div>
          )}

          {/* Modal Footer */}
          <div className="sticky bottom-0 pt-6 border-t border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="px-3 py-2 text-xs font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-800 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors border border-gray-300 dark:border-gray-700 disabled:opacity-50"
            >
              {t('product.edit.cancel')}
            </button>
            <button
              type="submit"
              disabled={loading}
              className={`px-3 py-2 text-xs font-medium text-white rounded-lg transition-colors shadow-sm flex items-center gap-2 ${
                !loading
                  ? "bg-[#171717] hover:bg-gray-800"
                  : "bg-gray-400 cursor-not-allowed"
              }`}
            >
              {loading ? (
                <>
                  <Loading size={5} />
                  {t('product.edit.updating')}
                </>
              ) : (
                <>
                  {t('product.edit.update')}
                </>
              )}
            </button>
          </div>

        </form>
      </div>
    </div>
  )
}